import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const EmailAlertModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "EmailAlertModalContainer" */
      './EmailAlertModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
